// extracted by mini-css-extract-plugin
export default {"Wrapper":"Informer_Wrapper__wFD-z"};